import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { Banner } from '../../../core/models/banner.model';

import { SettingsService } from '../../../core/services/settings.service';
import { PlatformService } from '../../../core/services/ssr/platform.service';

import SwiperCore, { Autoplay, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Pagination]);
SwiperCore.use([Autoplay]);

export interface BannersDetails {
  banners: Array<Banner>;
  bannerImageWidth: number;
  bannerImageHeight: number;
}

@Component({
  selector: 'app-banner-ads',
  templateUrl: './banner-ads.component.html',
  styleUrls: ['./banner-ads.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerAdsComponent {
  @ViewChild('scrollElement', { read: ElementRef })
  public scrollElement: ElementRef<HTMLElement>;

  @Output()
  public selectBanner = new EventEmitter<Banner>();

  public ads: Array<Banner>;
  public config: SwiperOptions;
  public sliderScrollingDirection: string;

  constructor(private settingsService: SettingsService, private platformService: PlatformService) {}

  @Input()
  public set banners(banners: Array<Banner>) {
    const { enabled, delay } = this.settingsService.getBannersAutoplayConfigForCurrentCountry();

    this.sliderScrollingDirection = this.settingsService.getLanguageDirection();
    this.config = {
      pagination: banners?.length > 1 ? { clickable: true } : false,
      slidesPerView: 1,
      spaceBetween: 16,
      autoplay: !!enabled && !!delay ? { delay, disableOnInteraction: false } : false,
      breakpoints: {
        [this.platformService.tabletMinScreenWidth]: { slidesPerView: 2 },
        [this.platformService.desktopMinScreenWidth]: { slidesPerView: 3 },
      },
    };

    this.ads = banners;
  }

  public getScrollElement(): HTMLElement {
    return this.scrollElement?.nativeElement || undefined;
  }
}
